import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";

export type CouponDto = {
    id: string;
    name: string;
    discountType: 'PERCENTAGE' | 'FIXED';
    discountValue: number;
    currency?: string;
    applicableTo: string[];
    expiresAt: string;
    maxUsagePerUser: number;
    organizationId: string;
    createdAt: string;
    assignedCount?: number;
    totalUsageCount?: number;
};

export const GET_COUPONS_QUERY_KEY = (organizationId: string) => ['coupons', 'list', organizationId];

export const useListCoupons = (organizationId: string) => {
    const client = useApiClient();

    return useQuery({
        queryKey: GET_COUPONS_QUERY_KEY(organizationId),
        queryFn: () => client.fetchApi<CouponDto[], {}>({
            endpoint: `coupons/admin/${organizationId}`,
            method: 'GET'
        }),
        enabled: !!organizationId,
    });
};
